












 








const node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "refreshSession",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AtmosphereRefreshSessionMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AtmosphereRefreshSessionMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "m_ih22MtLSoNjPyYgPVGJeiA",
    "metadata": {},
    "name": "AtmosphereRefreshSessionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "0c665121b15d92c060f9a84bd1478c70";

export default node;
